import { FC } from 'react'

import { Box, Divider, Skeleton } from '@mui/material'

/**
 * Layout-matched placeholder for `MotivationsPanel` — radar chart on the
 * left, bar chart on the right, divider + source legend below. Used by the
 * game page body while the initial fetch is in flight.
 */
export const MotivationsPanelSkeleton: FC = () => (
  <Box>
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3, alignItems: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Skeleton variant="circular" width={340} height={340} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Skeleton variant="text" width={120} height={18} />
            <Skeleton variant="rounded" sx={{ flex: 1 }} height={14} />
          </Box>
        ))}
      </Box>
    </Box>
    <Divider sx={{ my: 2 }} />
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
      {Array.from({ length: 3 }).map((_, i) => (
        <Skeleton key={i} variant="rounded" width={140} height={26} />
      ))}
    </Box>
  </Box>
)
